var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImportant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2606 0.705921C10.6915 -0.235307 9.30854 -0.235307 8.73939 0.705922L0.209167 14.8129C-0.373844 15.7771 0.331006 17 1.46978 17H18.5302C19.669 17 20.3738 15.7771 19.7908 14.8129L11.2606 0.705921ZM9.88541 1.37914C9.93715 1.29357 10.0629 1.29357 10.1146 1.37914L18.6448 15.4862C18.6979 15.5738 18.6337 15.685 18.5302 15.685H1.46978C1.36626 15.685 1.30218 15.5738 1.35518 15.4862L9.88541 1.37914ZM9.10202 5.80451C9.08242 5.30235 9.49015 4.88471 10 4.88471C10.5099 4.88471 10.9176 5.30235 10.898 5.80452L10.6927 11.0656C10.6784 11.4324 10.3725 11.7226 10 11.7226C9.62753 11.7226 9.32163 11.4324 9.30731 11.0656L9.10202 5.80451ZM11.0005 13.681C11.0005 14.2257 10.5525 14.6672 9.99987 14.6672C9.44725 14.6672 8.99928 14.2257 8.99928 13.681C8.99928 13.1364 9.44725 12.6948 9.99987 12.6948C10.5525 12.6948 11.0005 13.1364 11.0005 13.681Z",
    fill: "#FFAE24"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportant);
export default __webpack_public_path__ + "static/media/important.8ad3a1b9175c565e5ef28119c8c6d211.svg";
export { ForwardRef as ReactComponent };